<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-header">
        <div class="logo">{{ $t('login.title') }}</div>
        <p class="subtitle">{{ $t('login.subtitle') }}</p>
      </div>
      
      <div class="login-form">
        <div class="form-group">
          <input 
            type="text" 
            v-model="username" 
            class="form-input"
            :placeholder="$t('login.username')"
            @keydown.enter="handleLogin"
          />
        </div>
        
        <div class="form-group">
          <input 
            type="password" 
            v-model="password" 
            class="form-input"
            :placeholder="$t('login.password')"
            @keydown.enter="handleLogin"
          />
        </div>
        
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        
        <button 
          @click="handleLogin" 
          class="login-button"
          :disabled="!username || !password || isLoading"
        >
          <span v-if="isLoading">{{ $t('login.loggingIn') }}</span>
          <span v-else>{{ $t('login.login') }}</span>
        </button>
      </div>
      
      <div class="login-footer">
        <p class="description">
          {{ $t('login.description') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      // 预设的账号密码
      validCredentials: {
        username: 'admin',
        password: 'cau112233'
      }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.errorMessage = this.$t('login.inputError');
        return;
      }
      
      this.isLoading = true;
      this.errorMessage = '';
      
      // 模拟登录延迟
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 验证账号密码
      if (this.username === this.validCredentials.username && 
          this.password === this.validCredentials.password) {
        // 登录成功，生成token并存储到localStorage
        const token = this.generateToken();
        localStorage.setItem('auth_token', token);
        localStorage.setItem('login_time', Date.now().toString());
        
        // 跳转到主页
        this.$router.push('/');
      } else {
        this.errorMessage = this.$t('login.loginError');
        this.isLoading = false;
      }
    },
    
    generateToken() {
      // 生成一个简单的token
      const timestamp = Date.now();
      const randomStr = Math.random().toString(36).substring(2);
      return `pest_ai_${timestamp}_${randomStr}`;
    }
  },
  
  mounted() {
    // 如果已经登录，直接跳转到主页
    const token = localStorage.getItem('auth_token');
    if (token) {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "PingFangSC", "PingFang SC", Avenir, Helvetica, Arial, sans-serif;
}

.login-container {
  width: 400px;
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-header {
  margin-bottom: 40px;
}

.logo {
  font-family: FZLTTHK--GBK1, FZLTTHK--GBK1;
  font-weight: bold;
  font-size: 28px;
  color: #303030;
  line-height: 40px;
  margin-bottom: 10px;
}

.subtitle {
  font-weight: 500;
  font-size: 16px;
  color: #6A6A6A;
  line-height: 22px;
  margin: 0;
}

.login-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  height: 50px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 0 20px;
  font-size: 16px;
  color: #303030;
  background-color: #FFFFFF;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #249745;
}

.form-input::placeholder {
  color: #9A9A9A;
  font-size: 14px;
}

.error-message {
  color: #ff4757;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #fff5f5;
  border: 1px solid #fecaca;
  border-radius: 8px;
}

.login-button {
  width: 100%;
  height: 50px;
  background: #249745;
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.login-button:hover:not(:disabled) {
  background: #1b7035;
}

.login-button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.login-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.description {
  font-size: 14px;
  color: #888888;
  line-height: 20px;
  margin: 0;
}

@media (max-width: 480px) {
  .login-container {
    width: 90%;
    padding: 30px 20px;
  }
  
  .logo {
    font-size: 24px;
  }
  
  .subtitle {
    font-size: 14px;
  }
}
</style>